import { Component } from 'react';
import { connect } from 'react-redux';

// @ts-expect-error Untyped module
import AutoSaveContainer from 'ContentEditorUI/containers/AutoSaveContainer';
import { getSaveData, getCanSave
// @ts-expect-error Untyped module
} from 'page-editor-ui/redux/selectors/saveSelectors';
import { getHasContentModel } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
// @ts-expect-error Untyped module
import { validate } from 'page-editor-ui/redux/actions/pagePublishActions';
import { saveSettingsBuffer, fetchHasBufferedSettingsChanges } from 'theme-previewer-lib/actions/ThemeSettingsActions';
import { getCanUseUniversalThemeEditor } from 'page-editor-ui/redux/selectors/authSelectors';
import { getHasTheme } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { getHasThemeUnsavedChanges } from 'theme-previewer-lib/selectors/themeSettingsMetaSelectors';

// @ts-expect-error Untyped module
import { AUTOSAVE_THEME_SAVE_PERIOD } from 'page-editor-ui/Constants';
import { getIsEditingGridLayouts } from 'ContentEditorUI/redux/selectors/moduleSelectors';
// @ts-expect-error Untyped module
import { convertObjectToSnakeCase } from 'ContentEditorUI/utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
const keysForHardSave = ['name', 'language', 'domain', 'slug', 'campaign', 'campaign_name', 'campaign_utm'];
const keysToReload = [
// changes require preview reload
'domain', 'head_html', 'footer_html', 'include_default_custom_css', 'enable_domain_stylesheets', 'enable_layout_stylesheets', 'attached_stylesheets', 'language', 'html_title', 'meta_description', 'featured_image'];
const mapStateToProps = state => {
  const hasContentModel = getHasContentModel(state);
  return {
    saveData: hasContentModel ? getSaveData(state) : null,
    canSave: getCanSave(state),
    hasTheme: getHasTheme(state),
    hasThemeUnsavedChanges: getHasThemeUnsavedChanges(state),
    canUseUniversalThemeEditor: getCanUseUniversalThemeEditor(state),
    isEditingGridLayouts: getIsEditingGridLayouts(state)
  };
};
const mapDispatchToProps = {
  validate,
  saveSettingsBuffer,
  fetchHasBufferedSettingsChanges
};
class PageAutoSaveContainer extends Component {
  componentDidUpdate() {
    const {
      hasThemeUnsavedChanges,
      canUseUniversalThemeEditor
    } = this.props;
    if (hasThemeUnsavedChanges && canUseUniversalThemeEditor) {
      setTimeout(() => {
        this.props.saveSettingsBuffer({
          isAutoSave: true,
          fromUniversal: true
        });
        this.props.fetchHasBufferedSettingsChanges();
      }, AUTOSAVE_THEME_SAVE_PERIOD);
    }
  }
  render() {
    var _saveData$content;
    const {
      saveData,
      isAppReadyForSaving,
      autoSaveDebounced,
      autoSave,
      canSave,
      isEditingGridLayouts
    } = this.props;
    const _saveData = isEditingGridLayouts ? convertObjectToSnakeCase((_saveData$content = saveData === null || saveData === void 0 ? void 0 : saveData.content) !== null && _saveData$content !== void 0 ? _saveData$content : {}) : saveData;
    if (saveData && isAppReadyForSaving) {
      return /*#__PURE__*/_jsx(AutoSaveContainer, {
        autoSaveDebounced: autoSaveDebounced,
        autoSave: autoSave,
        saveData: _saveData,
        canSave: canSave,
        keysForHardSave: keysForHardSave,
        validate: this.props.validate,
        keysToReload: keysToReload
      });
    }
    return null;
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(PageAutoSaveContainer);